import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Button } from '@mui/material';

const ChangeUserButton = () => {
  const { logout, loginWithRedirect } = useAuth0();

  const handleChangeUser = async () => {
    await logout({ returnTo: window.location.origin });
    // Esperar un momento para asegurar que el logout se complete
    setTimeout(() => {
      // Forzar reautenticación con prompt: 'login'
      loginWithRedirect({ prompt: 'login' });
    }, 500); // Ajusta el tiempo de espera si es necesario
  };

  return (
    <Button onClick={handleChangeUser}>
      Change User
    </Button>
  );
};

export default ChangeUserButton;
